<div class="home-container">
<!-- Banner -->
<header class="banner">
  <div class="banner-content">
    <div class="logo-section">
      <div class="logo-container">
        <svg class="logo-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
        </svg>
      </div>
      <div class="logo-text-wrapper">
        <span class="logo-text">Premium Levels</span>
      </div>
    </div>
    <div class="header-actions">
      <div class="user-menu" *ngIf="currentUser" [class.open]="userMenuOpen" (click)="$event.stopPropagation()">
        <button type="button" class="user-profile" (click)="toggleUserMenu()" [attr.aria-expanded]="userMenuOpen" aria-haspopup="true" aria-label="Account menu">
          <div class="user-avatar">
            {{ currentUser.firstName.charAt(0) || 'U' }}
          </div>
          <span class="user-name">{{ currentUser.firstName }}</span>
          <svg class="user-caret" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        <div class="user-dropdown" role="menu">
          <button type="button" class="btn-logout-header" (click)="logout()" role="menuitem" aria-label="Logout from your account">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span class="btn-text">Sign out</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</header>

  <!-- Main Content -->
  <main class="main-content">
    <!-- Loading State -->
    <div class="loading-container" *ngIf="!settings">
      <div class="loading-spinner"></div>
      <p class="loading-text">Loading your settings...</p>
    </div>

    <!-- Messages (floating) -->
    <div class="message-container" *ngIf="settings && (successMessage || errorMessage)">
      <div class="message success-message" *ngIf="successMessage" role="alert">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
        {{ successMessage }}
      </div>
      <div class="message error-message" *ngIf="errorMessage" role="alert">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        {{ errorMessage }}
      </div>
    </div>

    <!-- Link TradingView Section (when userCredentialsSet is false) -->
    <div class="content-card link-card" *ngIf="settings && !settings.userCredentialsSet">
      <div class="card-header">
        <svg class="card-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
        </svg>
        <h3>Link Your TradingView Account</h3>
      </div>
      
      <div class="form-group">
        <label for="sessionId">SessionId</label>
        <input 
          type="text" 
          id="sessionId" 
          [(ngModel)]="sessionId" 
          placeholder="Enter Session ID"
          [disabled]="isLinking"
          aria-required="true"
          autocomplete="off"
        />
      </div>
      <div class="form-group">
        <label for="sessionIdSign">SessionId_Sign</label>
        <input 
          type="text" 
          id="sessionIdSign" 
          [(ngModel)]="sessionIdSign" 
          placeholder="Enter Session ID Sign"
          [disabled]="isLinking"
          aria-required="true"
          autocomplete="off"
        />
      </div>

      <button 
        class="btn-link-account" 
        (click)="linkTradingViewAccount()"
        [disabled]="isLinking"
        [attr.aria-busy]="isLinking"
      >
        <span *ngIf="isLinking" class="spinner"></span>
        {{ isLinking ? 'Linking...' : 'Link Account' }}
      </button>
    </div>

    <!-- Linked Account Section (when userCredentialsSet is true) -->
    <div class="content-card linked-card" *ngIf="settings && settings.userCredentialsSet">
      <!-- Status Bar -->
      <div class="status-bar">
        <div class="status-info">
          <svg class="status-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#27ae60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <span>TradingView Connected</span>
        </div>
        <div class="status-actions">
          <button 
            class="btn-refresh-small" 
            (click)="refreshTradingView()"
            [disabled]="isRefreshing"
            title="Fetch updated list of watchlists and charts"
          >
            <span *ngIf="isRefreshing" class="spinner-small"></span>
            <svg *ngIf="!isRefreshing" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle; margin-right: 4px;">
              <polyline points="23 4 23 10 17 10"></polyline>
              <polyline points="1 20 1 14 7 14"></polyline>
              <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
            </svg>
            <span *ngIf="!isRefreshing">Refresh</span>
          </button>
          <button 
            class="btn-unlink-small" 
            (click)="unlinkAccount()"
            [disabled]="isUnlinking"
          >
            <span *ngIf="isUnlinking" class="spinner-small"></span>
            <svg *ngIf="!isUnlinking" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle; margin-right: 4px;">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
            <span *ngIf="!isUnlinking">Unlink</span>
          </button>
        </div>
      </div>

      <div class="linked-layout" *ngIf="watchLists.length > 0 || charts.length > 0">
      <div class="linked-columns">
      <div class="linked-col linked-col-setup">
      <h4 class="col-heading">Settings</h4>
      <!-- Settings Grid -->
      <div class="settings-grid">
        <div class="form-group">
          <label for="watchList">
            <span class="label-with-info">
              <span class="label-text">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M7 8h10M7 12h10M7 16h6"/></svg>
                Watchlist
              </span>
              <span
                class="info-tooltip"
                tabindex="0"
                role="button"
                aria-label="Select the TradingView watchlist that provides the symbols used when Premium Levels are published."
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
                <span class="info-tooltip-text" role="tooltip">Select the TradingView watchlist that provides the symbols used when Premium Levels are published.</span>
              </span>
            </span>
          </label>
          <select 
            id="watchList" 
            [(ngModel)]="selectedWatchListId"
            (ngModelChange)="onWatchListChange()"
            [disabled]="isSaving"
          >
            <option [ngValue]="null">Select WatchList</option>
            <option *ngFor="let watchList of watchLists; trackBy: trackByWatchListId" [ngValue]="watchList.id">
              {{ watchList.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="chart">
            <span class="label-with-info">
              <span class="label-text">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <rect x="3" y="12" width="3" height="6"/>
                  <rect x="9" y="8" width="3" height="10"/>
                  <rect x="15" y="4" width="3" height="14"/>
                </svg>
                Chart
              </span>
              <span
                class="info-tooltip"
                tabindex="0"
                role="button"
                aria-label="Select the TradingView chart whose drawings are used to generate your Premium Levels indicator."
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
                <span class="info-tooltip-text" role="tooltip">Select the TradingView chart whose drawings are used to generate your Premium Levels indicator.</span>
              </span>
            </span>
          </label>
          <select 
            id="chart" 
            [(ngModel)]="selectedChartId"
            (ngModelChange)="onChartChange()"
            [disabled]="isSaving"
          >
            <option [ngValue]="null">Select Chart</option>
            <option *ngFor="let chart of charts; trackBy: trackByChartId" [ngValue]="chart.id">
              {{ chart.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group indicator-title-group">
        <label for="indicatorTitle">
          <span class="label-with-info">
            <span class="label-text">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
              </svg>
              Indicator Title
            </span>
            <span
              class="info-tooltip"
              tabindex="0"
              role="button"
              aria-label="This title appears on your TradingView indicator when Premium Levels are published."
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
              <span class="info-tooltip-text" role="tooltip">This title appears on your TradingView indicator when Premium Levels are published.</span>
            </span>
          </span>
        </label>
        <input
          type="text"
          id="indicatorTitle"
          [(ngModel)]="indicatorTitle"
          (ngModelChange)="onIndicatorTitleChange()"
          placeholder="Enter the title for your published indicator"
          maxlength="255"
          [disabled]="isSaving"
          aria-required="true"
        />
      </div>

      <!-- Empty Watchlist Error -->
      <div class="empty-watchlist-error" *ngIf="emptyWatchlistError">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <span>The selected watchlist contains no symbols. Please select a watchlist that contains symbols.</span>
      </div>

      <!-- Symbols (part of settings) -->
      <div class="symbols-section" *ngIf="selectedWatchListId && !emptyWatchlistError">
        <div class="always-fetch-option">
          <label class="checkbox-label">
            <input
              type="checkbox"
              [(ngModel)]="alwaysFetchLatestSymbols"
              (ngModelChange)="onAlwaysFetchChange()"
              [disabled]="isSaving"
            />
            <span class="checkbox-text">Always fetch up-to-date symbols when publishing Premium Levels</span>
          </label>
        </div>

        <div class="symbols-panel" *ngIf="symbolSelections.length > 0">
          <div class="symbols-panel-header">
            <span *ngIf="alwaysFetchLatestSymbols">Symbols ({{ symbolSelections.length }})</span>
            <span *ngIf="!alwaysFetchLatestSymbols">Select Symbols ({{ selectedSymbolsCount }}/{{ symbolSelections.length }})</span>
            <label class="simple-checkbox-label">
              <input
                type="checkbox"
                [(ngModel)]="simpleSymbolDisplay"
              />
              <span>Hide Exchange</span>
            </label>
          </div>

          <div class="symbols-panel-body">
            <div class="symbols-readonly-container" *ngIf="alwaysFetchLatestSymbols">
              <div class="symbols-readonly-list">
                <span *ngFor="let item of symbolSelections; trackBy: trackBySymbol" class="symbol-readonly-item">{{ getDisplaySymbol(item.symbol) }}</span>
              </div>
            </div>

            <div class="symbols-selection-container" *ngIf="!alwaysFetchLatestSymbols">
              <div class="symbols-selection-actions">
                <button type="button" class="btn-select-all" (click)="toggleAllSymbols(true)" [disabled]="isSaving">Select All</button>
                <button type="button" class="btn-deselect-all" (click)="toggleAllSymbols(false)" [disabled]="isSaving">Deselect All</button>
              </div>
              <div class="symbols-checkbox-list">
                <label *ngFor="let item of symbolSelections; trackBy: trackBySymbol" class="symbol-checkbox-label">
                  <input
                    type="checkbox"
                    [(ngModel)]="item.selected"
                    (ngModelChange)="onSymbolSelectionChange()"
                    [disabled]="isSaving"
                  />
                  <span class="symbol-name">{{ getDisplaySymbol(item.symbol) }}</span>
                </label>
              </div>
              <div class="no-symbols-selected-warning" *ngIf="!hasSelectedSymbols">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <span>Please select at least one symbol or enable "Always fetch up-to-date symbols".</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="symbols-placeholder" *ngIf="!selectedWatchListId && !emptyWatchlistError">
        <span>Select a watchlist to view and configure symbols.</span>
      </div>

      <!-- Save Button -->
      <button
        class="btn-save-settings"
        (click)="saveSettings()"
        [disabled]="!canSaveSettings || isSaving"
      >
        <span *ngIf="isSaving" class="spinner"></span>
        <svg *ngIf="!isSaving" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
          <polyline points="17 21 17 13 7 13 7 21"></polyline>
          <polyline points="7 3 7 8 15 8"></polyline>
        </svg>
        {{ isSaving ? 'Saving...' : 'Save Settings' }}
      </button>
      </div>

      <div class="linked-col linked-col-schedule" *ngIf="showPublishButton">
        <div class="schedule-col-header">
          <h4 class="col-heading">Scheduled Publishing</h4>
          <label class="schedule-toggle">
            <input
              type="checkbox"
              [(ngModel)]="scheduleEnabled"
              (ngModelChange)="onScheduleEnabledChange()"
              [disabled]="scheduleToggleDisabled"
            />
            <span class="toggle-track" aria-hidden="true"></span>
          </label>
        </div>
        <div class="schedule-section">
          <div class="schedule-loading" *ngIf="isScheduleLoading">
            <span class="spinner-small"></span>
            <span>Loading schedule...</span>
          </div>

          <div class="schedule-body" *ngIf="!isScheduleLoading">
            <div class="schedule-warning" *ngIf="!publishSettingsReady">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <span>Save publish settings and complete admin approval before enabling a schedule.</span>
            </div>

            <div class="schedule-days" [class.schedule-controls-disabled]="!scheduleEnabled">
              <label
                *ngFor="let day of weekDays"
                class="schedule-day"
                [class.selected]="isScheduleDaySelected(day)"
              >
                <input
                  type="checkbox"
                  [checked]="isScheduleDaySelected(day)"
                  (change)="toggleScheduleDay(day)"
                  [disabled]="!scheduleEnabled || isScheduleSaving"
                />
                <span>{{ day.slice(0, 3) }}</span>
              </label>
            </div>

            <div class="schedule-grid" [class.schedule-controls-disabled]="!scheduleEnabled">
              <div class="form-group">
                <label for="scheduleTime">Time</label>
                <input
                  type="time"
                  id="scheduleTime"
                  [(ngModel)]="scheduleTime"
                  (ngModelChange)="onScheduleChange()"
                  [disabled]="!scheduleEnabled || isScheduleSaving"
                />
              </div>

              <div class="form-group">
                <label for="scheduleTimeZone">Timezone</label>
                <select
                  id="scheduleTimeZone"
                  [(ngModel)]="scheduleTimeZone"
                  (ngModelChange)="onScheduleChange()"
                  [disabled]="!scheduleEnabled || isScheduleSaving"
                >
                  <option *ngFor="let zone of timeZoneOptions" [ngValue]="zone.id">
                    {{ zone.label }}
                  </option>
                </select>
              </div>
            </div>

            <button
              type="button"
              class="btn-save-schedule"
              (click)="savePublishSchedule()"
              [disabled]="!canSaveSchedule"
            >
              <span *ngIf="isScheduleSaving" class="spinner"></span>
              <svg *ngIf="!isScheduleSaving" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                <polyline points="17 21 17 13 7 13 7 21"></polyline>
                <polyline points="7 3 7 8 15 8"></polyline>
              </svg>
              {{ isScheduleSaving ? 'Saving...' : 'Save Schedule' }}
            </button>

            <div class="schedule-summary" *ngIf="publishSchedule">
              <div class="schedule-summary-row">
                <span>Next Run</span>
                <strong>{{ scheduleEnabled ? formatScheduleDate(publishSchedule.nextRunAtUtc) : 'Disabled' }}</strong>
              </div>
              <div class="schedule-summary-row">
                <span>Last Run</span>
                <strong>{{ formatScheduleDate(publishSchedule.lastRunAtUtc) }}</strong>
              </div>
              <div class="schedule-summary-row">
                <span>Status</span>
                <strong [class]="scheduleStatusClass">{{ publishSchedule.lastStatus || 'No runs yet' }}</strong>
              </div>
              <div class="schedule-last-message" *ngIf="publishSchedule.lastMessage">
                {{ publishSchedule.lastMessage }}
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <div class="publish-actions" *ngIf="showPublishButton">
        <div class="pending-approval-tip" *ngIf="showPendingApprovalTip">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>Pending Admin Approval</span>
        </div>
        <button
          class="btn-publish"
          (click)="publishPremiumLevels()"
          [disabled]="publishButtonDisabled"
        >
          <span *ngIf="isPublishing" class="spinner"></span>
          <svg *ngIf="!isPublishing" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
          </svg>
          {{ isPublishing ? 'Publishing...' : 'Publish Premium Levels' }}
        </button>
      </div>
      </div>
    </div>
  </main>
</div>
